import React from 'react';
import { Box, Image } from '@chakra-ui/react';

// Render icon thống nhất bất kể icon là React component (react-icons)
// hay PNG asset (Threads). Dùng box wrapper để giữ size cố định.
const PlatformIcon = ({ platform, size = 24, color }) => {
  const { icon: Icon, iconImage, name } = platform;

  if (Icon) {
    return <Icon size={size} color={color || platform.color} />;
  }

  if (iconImage) {
    return (
      <Image
        src={iconImage}
        alt={`${name} logo`}
        boxSize={`${size}px`}
        objectFit="contain"
      />
    );
  }

  return <Box boxSize={`${size}px`} bg="gray.200" borderRadius="md" />;
};

export default PlatformIcon;
